module.exports = __webpack_public_path__ + "static/img/interactive-img4.6297819.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/interactive-img4.jpg
// module id = 330
// module chunks = 64